import React, { Component } from "react";
import PropTypes from "prop-types";
import { ColorPicker } from "components";
import { css } from "react-emotion";

const col = css`
  flex: 0 0 92%;
`;

const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  margin-bottom: 35px;
  height: 80px;
  width: 100%;
  margin: auto;
  margin-bottom: 0px;
`;

const ApplicationColorForm = ({ application, update, updateNav }) => {
  const {
    view: {
      navigation: { navBarColor },
    },
    primaryColor,
    secondaryColor,
    tertiaryColor,
  } = application;

  return (
    <div className={row + " colors"}>
      <div className={col} style={{ height: "80px" }}>
        <ColorPicker
          zIndex="5"
          width="100%"
          height="81px"
          title="Navigation Bar Color"
          onChange={updateNav("navBarColor")}
          color={navBarColor}
          marginLeft="28px"
        />
        {/* <ColorPicker 
        zIndex='4'
        width='80%'
        title='Navigation Page Color:'
        onChange={update('secondaryColor')}
        color={secondaryColor}/> */}
        {/* <ColorPicker 
        zIndex='3'
        width='80%'
        title='Pick your Tertiary Color:'
        onChange={update('tertiaryColor')}
        color={tertiaryColor}/>                */}
      </div>
    </div>
  );
};

ApplicationColorForm.propTypes = {
  application: PropTypes.object,
  update: PropTypes.func,
};

export default ApplicationColorForm;
